<template>
    <!-- 大于3个 -->
    <div class="flex flex-col gap-y-6 pb-6">
        <!-- 第一行 -->
        <div class="grid grid-cols-3 gap-6">
            <AddProjectPlayCard :project="projects[0]" @remove-project="handleRemoveProject" @pin-project="handlePinProject"
                                @cancel-pin-project="handleCancelPinProject" />

            <ProjectCard class="col-span-2" size="lg" :project="projects[0]" @remove-project="handleRemoveProject"
                         @pin-project="handlePinProject" @cancel-pin-project="handleCancelPinProject" />

        </div>

        <!-- 剩下的行 -->
        <div class="grid grid-cols-3 gap-6" v-for="(item, index) in combineLeftProjects" :key="index">

            <ProjectCard :project="item[0]" @remove-project="handleRemoveProject" @pin-project="handlePinProject"
                         @cancel-pin-project="handleCancelPinProject" />

            <div class="col-span-2 grid grid-cols-2 gap-6">
                <ProjectCard :project="item[1]" @remove-project="handleRemoveProject" @pin-project="handlePinProject"
                             @cancel-pin-project="handleCancelPinProject" />
                <ProjectCard :project="item[2]" @remove-project="handleRemoveProject" @pin-project="handlePinProject"
                             @cancel-pin-project="handleCancelPinProject" />
            </div>

        </div>
    </div>
</template>

<script setup lang="ts">
import type { IProject } from '@/types';
import ProjectCard from './ProjectCard.vue'
import { computed } from 'vue';
import _ from 'lodash'
import AddProjectPlayCard from './AddProjectPlayCard.vue'
const props = defineProps<{
    projects: IProject[]
}>()

const emits = defineEmits<{
    (e: 'remove-project', id: string): void
    (e: 'pin-project', id: string): void
    (e: 'cancel-pin-project', id: string): void
}>()

const combineLeftProjects = computed(() => {
    const dropProjects = _.drop(props.projects, 1)
    return _.chunk(dropProjects, 3)
})

function handleRemoveProject(id: string) {
    emits('remove-project', id)
}

function handlePinProject(id: string) {
    emits('pin-project', id)
}

function handleCancelPinProject(id: string) {
    emits('cancel-pin-project', id)
}

</script>
